// ============================================
// フォーム
// ============================================

//住所自動入力
// ==========================
function addAutoFunc() {
  const zipInput = document.querySelector('[name="zip"]');
  const addInput = document.querySelector('[name="address"]');
  if (!zipInput || !addInput) return;

  zipInput.classList.add('p-postal-code');
  addInput.classList.add('p-region', 'p-locality', 'p-street-address', 'p-extended-address');

  new YubinBango.MicroformatDom();
}

// Contact form 7 確認画面
// ==========================
function confirmForm() {
  const escapeName = (name) => (window.CSS?.escape ? window.CSS.escape(name) : String(name).replace(/["\\]/g, '\\$&'));

  const normalizeName = (name) => String(name || '').replace(/\[\]$/, '');

  document.querySelectorAll('.wpcf7 form').forEach((form) => {
    if (form.dataset.cf7ConfirmBound === '1') return;

    const inputsWrap = form.querySelector('[data-inputs]');
    const confirmWrap = form.querySelector('[data-confirm]');
    const toConfirm = form.querySelector('[data-to-confirm]');
    const backBtn = form.querySelector('[data-back]');
    const sendBtn = form.querySelector('[data-send]');
    const sendWrap = form.querySelector('[data-to-send]');
    const cf7Submits = form.querySelectorAll('.wpcf7-submit'); // 複数想定

    if (!inputsWrap || !confirmWrap || !toConfirm || !backBtn || !sendBtn || cf7Submits.length === 0) {
      return;
    }

    form.dataset.cf7ConfirmBound = '1';

    cf7Submits.forEach((submit) => {
      submit.style.display = 'none';
    });

    const hide = (el) => {
      if (!el) return;
      el.setAttribute('hidden', '');
      el.style.display = 'none';
    };

    const show = (el, display = '') => {
      if (!el) return;
      el.removeAttribute('hidden');
      el.style.display = display;
    };

    const getHeaderOffset = () => {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');

      return -(parseFloat(value) || 0);
    };

    const scrollToForm = () => {
      const target = document.querySelector('#form');
      if (!target) return;

      requestAnimationFrame(() => {
        const top = window.scrollY + target.getBoundingClientRect().top + getHeaderOffset();

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      });
    };

    const getThanksUrl = () => {
      const currentUrl = new URL(window.location.href);
      const basePath = currentUrl.pathname.endsWith('/') ? currentUrl.pathname : `${currentUrl.pathname}/`;

      return `${currentUrl.origin}${basePath}thanks/`;
    };

    /**
     * ステップ表示の-current切り替え
     *
     * 0 = お問い合わせ
     * 1 = 確認・送信
     * 2 = 完了
     */
    const setStepCurrent = (index) => {
      const items = document.querySelectorAll('.c-form__list .c-form__item');

      items.forEach((item, i) => {
        item.classList.toggle('-current', i === index);
      });
    };

    // 初期表示：お問い合わせ
    setStepCurrent(0);

    show(inputsWrap);
    show(toConfirm);
    hide(confirmWrap);
    hide(sendWrap);
    hide(backBtn);
    hide(sendBtn);

    const disableSending = () => {
      sendBtn.disabled = true;
      sendBtn.setAttribute('aria-busy', 'true');

      cf7Submits.forEach((b) => {
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
      });

      // スピナーはCF7が出すのでここでは触らない
    };

    const enableSending = () => {
      sendBtn.disabled = false;
      sendBtn.removeAttribute('aria-busy');

      cf7Submits.forEach((b) => {
        b.disabled = false;
        b.removeAttribute('aria-busy');
      });
    };

    const hideDefaultSubmits = () => {
      cf7Submits.forEach((el) => {
        hide(el);

        const sp = el.nextElementSibling;
        if (sp && sp.classList.contains('wpcf7-spinner')) {
          sp.style.display = 'none';
        }
      });
    };

    const showDefaultSubmits = () => {
      cf7Submits.forEach((el) => {
        show(el, '');

        const sp = el.nextElementSibling;
        if (sp && sp.classList.contains('wpcf7-spinner')) {
          sp.style.display = '';
        }
      });
    };

    // 必須(aria-required含む)の事前チェック
    const validateBeforeConfirm = () => {
      form.querySelectorAll('[name]').forEach((el) => {
        el.setCustomValidity?.('');
      });

      const requiredControls = form.querySelectorAll('[name][required], [name][aria-required="true"], .wpcf7-validates-as-required [name]');

      const checkedGroups = new Set();
      let firstInvalid = null;

      requiredControls.forEach((el) => {
        const name = el.name;
        if (!name) return;

        if (el.type === 'checkbox' || el.type === 'radio') {
          if (checkedGroups.has(name)) return;
          checkedGroups.add(name);

          const group = form.querySelectorAll(`[name="${escapeName(name)}"]`);

          if (!Array.from(group).some((i) => i.checked)) {
            const head = group[0];
            head?.setCustomValidity?.('この項目は必須です');

            if (!firstInvalid) {
              firstInvalid = head;
            }
          }
        } else if (el.tagName === 'SELECT') {
          if (!el.value) {
            el.setCustomValidity('この項目は必須です');

            if (!firstInvalid) {
              firstInvalid = el;
            }
          }
        } else {
          if (!(el.value || '').trim()) {
            el.setCustomValidity('この項目は必須です');

            if (!firstInvalid) {
              firstInvalid = el;
            }
          }
        }
      });

      const ok = form.reportValidity();

      if (!ok && firstInvalid) {
        firstInvalid.focus();
      }

      return ok;
    };

    // 確認画面に値を流し込む
    const populateConfirm = () => {
      form.querySelectorAll('[name]').forEach((el) => {
        const name = el.name;
        if (!name) return;

        const fieldName = normalizeName(name);
        let value = '';

        if (el.type === 'file') {
          value = Array.from(el.files || [])
            .map((file) => file.name)
            .join(', ');
        } else if (el.type === 'checkbox') {
          const checked = form.querySelectorAll(`input[name="${escapeName(name)}"]:checked`);

          value = Array.from(checked)
            .map((i) => i.value)
            .join(', ');

          if (fieldName === 'privacy') {
            value = checked.length ? '同意する' : '未同意';
          }
        } else if (el.type === 'radio') {
          const checked = form.querySelector(`input[name="${escapeName(name)}"]:checked`);

          value = checked ? checked.value : '';
        } else if (el.tagName === 'SELECT') {
          value = el.value || '';
        } else {
          value = el.value ?? '';
        }

        const slot = form.querySelector(`[data-field="${escapeName(name)}"], [data-field="${escapeName(fieldName)}"]`);

        if (slot) {
          slot.textContent = value;
        }
      });
    };

    // 入力 → 確認
    toConfirm.addEventListener('click', (e) => {
      e.preventDefault(); // 万一 submit でも送らせない

      if (!validateBeforeConfirm()) return;

      populateConfirm();

      hide(inputsWrap);
      show(confirmWrap);
      hide(toConfirm);
      hideDefaultSubmits(); // 入力用送信は隠す
      show(sendWrap);
      show(backBtn, '');
      show(sendBtn, '');

      // ステップ表示：確認・送信
      setStepCurrent(1);

      scrollToForm();
    });

    // 確認 → 戻る
    backBtn.addEventListener('click', (e) => {
      e.preventDefault();

      show(inputsWrap);
      hide(confirmWrap);
      show(toConfirm);
      showDefaultSubmits();
      hide(sendWrap);
      hide(backBtn);
      hide(sendBtn);

      // ステップ表示：お問い合わせ
      setStepCurrent(0);

      const firstInput = inputsWrap.querySelector('input, textarea, select');
      firstInput?.focus();
    });

    // 送信開始（CF7 5.8+）
    form.addEventListener('wpcf7beforesubmit', () => {
      disableSending();
    });

    // エラー時：入力へ戻す & エラー文表示
    const backToInputOnError = (apiResponse) => {
      // 確認表示中なら戻す
      if (!confirmWrap.hasAttribute('hidden')) {
        backBtn.click();
      }

      // 念のためステップ表示：お問い合わせ
      setStepCurrent(0);

      // エラーテキストを拾って強調（.wpcf7-response-output はCF7が描画）
      const msg = form.querySelector('.wpcf7-response-output')?.textContent?.trim();

      if (msg) {
        // 任意：入力ブロックの上に独自表示枠があるなら挿入
        // 例: <div data-error></div> を用意していれば
        const box = form.querySelector('[data-error]');

        if (box) {
          box.textContent = msg;
          box.removeAttribute('hidden');
        }
      }

      // REST nonce 期限切れやキャッシュ起因のときは再初期化を試す
      const code = apiResponse?.code || apiResponse?.status;

      if (code === 'rest_invalid_nonce' || code === 'aborted') {
        // 可能ならフォームの再初期化（なければページ遷移でリロードを案内）
        try {
          window.wpcf7 && window.wpcf7.init && window.wpcf7.init(form);
        } catch (e) {}
      }

      enableSending();

      // エラー位置へスクロール
      const target = form.querySelector('.wpcf7-not-valid') || form.querySelector('[aria-invalid="true"]') || form.querySelector('.wpcf7-response-output');

      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      target?.focus?.();
    };

    // CF7イベント
    form.addEventListener('wpcf7invalid', (e) => {
      backToInputOnError(e.detail?.apiResponse);
    });

    form.addEventListener('wpcf7spam', (e) => {
      backToInputOnError(e.detail?.apiResponse);
    });

    form.addEventListener('wpcf7mailfailed', (e) => {
      backToInputOnError(e.detail?.apiResponse);
    });

    // 結果統合ハンドラ（成功/失敗を一本で判定）
    form.addEventListener('wpcf7submit', (e) => {
      const status = e.detail?.apiResponse?.status;
      // 'mail_sent' | 'validation_failed' | 'spam' | 'mail_failed' | 'aborted' など

      if (status === 'mail_sent') {
        // ステップ表示：完了
        setStepCurrent(2);

        // 成功時：thanksへ遷移
        location.href = getThanksUrl();
      } else {
        backToInputOnError(e.detail?.apiResponse);
      }

      // 念のため解除
      enableSending();
    });

    // リセット時は入力へ戻す
    form.addEventListener('reset', () => {
      if (!confirmWrap.hasAttribute('hidden')) {
        backBtn.click();
      }

      // ステップ表示：お問い合わせ
      setStepCurrent(0);

      enableSending();
    });
  });
}

export { addAutoFunc, confirmForm };
